import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { CoreService } from 'app/services/entidades/core.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class TimeService extends CoreService {

  constructor(
    private _http: Http
  ) {
    super(_http);
  }

  /**
   * Servicio para agregar horas a un caso
   * @param   {any} eventTime Datos del tiempo trabajado
   * @returns {any}           Objeto json con los resultados del insert
   */
  addTimer(eventTime: any): Observable<any> {
    return this.postMethod('time/', eventTime);
  }

  /**
   * Obtiene las horas trabajadas de un caso en particular
   * @param  {number} idcaso ID del caso
   * @return {any}           Objeto json con los datos de las horas de un caso
   */
  getLast(idcaso: number): Observable<any> {
    return this.getMethod(`time/last/${idcaso}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/entidades/time.service.ts